/* ==========================================================================
   El Ritual - comportamiento de la landing
   Nada de librerias. Todo transform y opacity.
   ========================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cl01 = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };

  /* ---------------- header: solido al hacer scroll ---------------- */
  function initHeader() {
    var hdr = $('#er-hdr');
    if (!hdr) return;
    var sobreHero = hdr.getAttribute('data-hero') === '1';
    function onScroll() {
      var arriba = window.scrollY < 24;
      hdr.dataset.solid = (arriba && sobreHero && !megaAbierto) ? '0' : '1';
      hdr.dataset.over = (arriba && sobreHero && !megaAbierto) ? '1' : '0';
    }
    var megaAbierto = false;
    var mega = $('#er-mega');
    var paneles = {};
    $$('#er-mega [data-panel]').forEach(function (p) { paneles[p.getAttribute('data-panel')] = p; });

    function abrir(id) {
      if (!mega || !paneles[id]) return;
      Object.keys(paneles).forEach(function (k) { paneles[k].hidden = k !== id; });
      mega.dataset.open = '1';
      megaAbierto = true;
      $$('#er-nav [data-mega]').forEach(function (b) {
        b.setAttribute('aria-expanded', String(b.getAttribute('data-mega') === id));
      });
      onScroll();
    }
    function cerrar() {
      if (!mega) return;
      mega.dataset.open = '0';
      megaAbierto = false;
      $$('#er-nav [data-mega]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      onScroll();
    }
    var nav = $('#er-nav');
    if (nav) {
      nav.addEventListener('mouseover', function (e) {
        var b = e.target.closest('[data-mega]');
        if (b) abrir(b.getAttribute('data-mega'));
      });
      nav.addEventListener('focusin', function (e) {
        var b = e.target.closest('[data-mega]');
        if (b) abrir(b.getAttribute('data-mega'));
      });
    }
    hdr.addEventListener('mouseleave', cerrar);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { cerrar(); cerrarMenuMobile(); } });

    var burger = $('#er-burger'), mnav = $('#er-mnav'), scrim = $('#er-scrim');
    function abrirMenuMobile() {
      if (!mnav) return;
      mnav.dataset.open = '1'; mnav.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.dataset.open = '1';
      document.body.style.overflow = 'hidden';
    }
    function cerrarMenuMobile() {
      if (!mnav) return;
      mnav.dataset.open = '0'; mnav.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.dataset.open = '0';
      document.body.style.overflow = '';
    }
    if (burger) burger.addEventListener('click', abrirMenuMobile);
    var mx = $('#er-mnav-x'); if (mx) mx.addEventListener('click', cerrarMenuMobile);
    if (scrim) scrim.addEventListener('click', cerrarMenuMobile);

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- carrusel de mates de autor ---------------- */
  function initCarrusel() {
    var sec = $('#er-show');
    if (!sec) return;
    var slides = $$('[data-slide]', sec);
    if (!slides.length) return;
    var i = 0, ocupado = false;
    var txt = $('#er-show-txt', sec), img = $('#er-show-img', sec);
    var contador = $('#er-show-i', sec);

    function pintar() {
      var d = slides[i];
      $('#er-show-k', sec).textContent = d.getAttribute('data-kicker') || '';
      $('#er-show-t', sec).textContent = d.getAttribute('data-headline') || '';
      $('#er-show-s', sec).textContent = d.getAttribute('data-slogan') || '';
      $('#er-show-n', sec).textContent = d.getAttribute('data-nombre') || '';
      $('#er-show-ill', sec).setAttribute('href', '#' + (d.getAttribute('data-ill') || 'i-mate'));
      var cta = $('#er-show-cta', sec);
      cta.textContent = d.getAttribute('data-cta') || 'Ver el producto';
      var url = d.getAttribute('data-url');
      if (url) { cta.href = url; cta.removeAttribute('aria-disabled'); }
      else { cta.removeAttribute('href'); cta.setAttribute('aria-disabled', 'true'); }
      var foto = d.getAttribute('data-foto');
      var caja = $('#er-show-foto', sec);
      if (caja) {
        if (foto) { caja.style.backgroundImage = 'url(' + foto + ')'; caja.dataset.hay = '1'; }
        else { caja.style.backgroundImage = ''; caja.dataset.hay = '0'; }
      }
      sec.dataset.t = d.getAttribute('data-tono') || 'trigo';
      if (contador) contador.textContent = String(i + 1);
    }
    function mover(dir) {
      if (ocupado) return;
      ocupado = true;
      i = (i + dir + slides.length) % slides.length;
      if (txt) txt.dataset.out = '1';
      if (img) img.dataset.out = '1';
      setTimeout(function () {
        pintar();
        if (txt) txt.dataset.out = '0';
        if (img) img.dataset.out = '0';
        setTimeout(function () { ocupado = false; }, 320);
      }, 300);
    }
    var prev = $('#er-show-prev', sec), next = $('#er-show-next', sec);
    if (prev) prev.addEventListener('click', function () { mover(-1); });
    if (next) next.addEventListener('click', function () { mover(1); });
    var x0 = null;
    sec.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    sec.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 44) mover(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
    pintar();
  }

  /* ---------------- experiencia termo -> agua -> mate ---------------- */
  function initRitual() {
    var RS = $('#er-rs'), STAGE = $('#er-rs-stage');
    if (!RS || !STAGE) return;
    var FLM = $('#er-fl-main'), FLH = $('#er-fl-halo'), DROP = $('#er-fl-drop');
    var flen = 0, pendiente = false, actual = -1;
    var PASOS = [0.20, 0.44, 0.66];

    function medir() { try { flen = FLM.getTotalLength(); } catch (e) { flen = 0; } }

    function pintar() {
      pendiente = false;
      var total = RS.offsetHeight - STAGE.offsetHeight;
      if (total <= 0) return;
      var p = cl01(-RS.getBoundingClientRect().top / total);
      var st = STAGE.style;
      var b = cl01((p - 0.06) / 0.62);
      var a = Math.pow(cl01((p - 0.34) / 0.34), 1.9);
      var das = Math.max(0, b - a).toFixed(4) + ' 1', off = (-a).toFixed(4);
      FLM.style.strokeDasharray = das; FLM.style.strokeDashoffset = off;
      FLH.style.strokeDasharray = das; FLH.style.strokeDashoffset = off;
      st.setProperty('--er-pour', cl01(p / 0.09).toFixed(3));
      st.setProperty('--er-stream', b.toFixed(4));
      st.setProperty('--er-fill', cl01((p - 0.64) / 0.20).toFixed(3));
      st.setProperty('--er-logo', cl01((p - 0.85) / 0.13).toFixed(3));
      if (flen && DROP) {
        var pt = FLM.getPointAtLength(b * flen);
        DROP.setAttribute('cx', pt.x.toFixed(1));
        DROP.setAttribute('cy', pt.y.toFixed(1));
        DROP.style.opacity = (b > 0 && b < 1 ? Math.min(1, 4 * b * (1 - b)) : 0).toFixed(3);
      }
      var idx = p < 0.34 ? 0 : p < 0.58 ? 1 : 2;
      if (idx !== actual) {
        actual = idx;
        STAGE.dataset.st = String(idx);
        $$('.rs-st', RS).forEach(function (el) {
          el.classList.toggle('on', Number(el.getAttribute('data-row')) === idx);
        });
      }
    }
    function agendar() { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }
    function irA(fila) {
      var total = RS.offsetHeight - STAGE.offsetHeight;
      if (total <= 0) return;
      var top = RS.getBoundingClientRect().top + window.scrollY + PASOS[fila] * total;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    $$('.rs-dots button', RS).forEach(function (b) {
      b.addEventListener('click', function () { irA(Number(b.getAttribute('data-row'))); });
    });
    $$('.rs-st', RS).forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (!el.classList.contains('on')) { e.preventDefault(); irA(Number(el.getAttribute('data-row'))); }
      });
    });

    if (REDUCED) {
      var st = STAGE.style;
      ['--er-pour', '--er-stream', '--er-fill', '--er-logo'].forEach(function (k) { st.setProperty(k, '1'); });
      FLM.style.strokeDasharray = '1 1'; FLH.style.strokeDasharray = '1 1';
      if (DROP) DROP.style.opacity = '0';
      STAGE.dataset.st = '1';
      $$('.rs-st', RS).forEach(function (el) { el.classList.add('on'); });
      return;
    }
    medir(); pintar();
    window.addEventListener('scroll', agendar, { passive: true });
    window.addEventListener('resize', function () { medir(); agendar(); });
  }

  /* ---------------- reservas del local ---------------- */
  function initReservas() {
    var raiz = $('#er-resv');
    if (!raiz) return;
    var HORARIO = JSON.parse(raiz.getAttribute('data-horario') || '{}');
    var WA = raiz.getAttribute('data-wa') || '';
    var hhmm = function (m) {
      return String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');
    };
    var franjas = function (a, b) { var o = []; for (var m = a; m <= b - 30; m += 30) o.push(m); return o; };
    var mismoDia = function (a, b) {
      return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    };
    var R = { cur: new Date(), fecha: null, hora: null, gente: null };
    R.cur.setDate(1);
    var hoy = new Date(); hoy.setHours(0, 0, 0, 0);

    function pintarCal() {
      var y = R.cur.getFullYear(), mo = R.cur.getMonth();
      var ml = R.cur.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
      $('#er-cal-m', raiz).textContent = ml.charAt(0).toUpperCase() + ml.slice(1);
      var lead = (new Date(y, mo, 1).getDay() + 6) % 7;
      var dias = new Date(y, mo + 1, 0).getDate();
      var h = '';
      for (var k = 0; k < lead; k++) h += '<span class="pad"></span>';
      for (var d = 1; d <= dias; d++) {
        var dt = new Date(y, mo, d);
        var pasado = dt < hoy;
        var sel = R.fecha && mismoDia(dt, R.fecha);
        h += '<button type="button" data-d="' + d + '"' + (pasado ? ' disabled' : '') +
             ' aria-pressed="' + (!!sel) + '">' + d + '</button>';
      }
      $('#er-cal-d', raiz).innerHTML = h;
      var lim = new Date();
      $('#er-cal-prev', raiz).disabled = new Date(y, mo, 1) <= new Date(lim.getFullYear(), lim.getMonth(), 1);
    }
    function pintarHoras() {
      var paso = $('#er-step-h', raiz);
      if (!R.fecha) {
        paso.dataset.off = '1';
        $('#er-slots', raiz).innerHTML = '';
        $('#er-step-h-i', raiz).textContent = 'Elegí primero una fecha';
        return;
      }
      paso.dataset.off = '0';
      var cfg = HORARIO[String(R.fecha.getDay())];
      $('#er-step-h-i', raiz).textContent =
        R.fecha.toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long' });
      if (!cfg) { $('#er-slots', raiz).innerHTML = '<span class="slot-lbl">Cerrado</span>'; return; }
      var chip = function (m) {
        return '<button type="button" class="slot" data-t="' + m + '" aria-pressed="' +
               (R.hora === m) + '">' + hhmm(m) + '</button>';
      };
      $('#er-slots', raiz).innerHTML =
        '<span class="slot-lbl">Mañana</span>' + franjas(cfg.m[0], cfg.m[1]).map(chip).join('') +
        '<span class="slot-lbl">Tarde y noche' + (cfg.cierre ? ' — el cierre se confirma por chat' : '') +
        '</span>' + franjas(cfg.t[0], cfg.t[1]).map(chip).join('');
    }
    function pintarGente() {
      $('#er-step-p', raiz).dataset.off = R.hora === null ? '1' : '0';
      $('#er-people', raiz).innerHTML = [1, 2, 3, 4, 5, 6, 8, 10, 12].map(function (n) {
        return '<button type="button" class="slot" data-p="' + n + '" aria-pressed="' +
               (R.gente === n) + '">' + n + (n === 12 ? '+' : '') + '</button>';
      }).join('');
      $('#er-step-n', raiz).dataset.off = R.gente === null ? '1' : '0';
    }
    function pintarResumen() {
      var listo = R.fecha && R.hora !== null && R.gente !== null;
      $('#er-resv-go', raiz).disabled = !listo;
      var sum = $('#er-resv-sum', raiz);
      sum.hidden = !listo;
      if (listo) {
        sum.innerHTML = '<b>Tu reserva</b>' +
          R.fecha.toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long' }) +
          ' &middot; ' + hhmm(R.hora) + ' &middot; ' + R.gente + (R.gente === 12 ? ' o más' : '') +
          (R.gente === 1 ? ' persona' : ' personas');
      }
    }
    function todo() { pintarCal(); pintarHoras(); pintarGente(); pintarResumen(); }

    $('#er-cal-prev', raiz).addEventListener('click', function () { R.cur.setMonth(R.cur.getMonth() - 1); pintarCal(); });
    $('#er-cal-next', raiz).addEventListener('click', function () { R.cur.setMonth(R.cur.getMonth() + 1); pintarCal(); });
    $('#er-cal-d', raiz).addEventListener('click', function (e) {
      var b = e.target.closest('[data-d]');
      if (!b || b.disabled) return;
      R.fecha = new Date(R.cur.getFullYear(), R.cur.getMonth(), Number(b.getAttribute('data-d')));
      R.hora = null; R.gente = null; todo();
    });
    $('#er-slots', raiz).addEventListener('click', function (e) {
      var b = e.target.closest('[data-t]');
      if (!b) return;
      R.hora = Number(b.getAttribute('data-t')); R.gente = null;
      pintarHoras(); pintarGente(); pintarResumen();
    });
    $('#er-people', raiz).addEventListener('click', function (e) {
      var b = e.target.closest('[data-p]');
      if (!b) return;
      R.gente = Number(b.getAttribute('data-p'));
      pintarGente(); pintarResumen();
    });
    $('#er-resv-go', raiz).addEventListener('click', function () {
      if (!R.fecha || R.hora === null || R.gente === null) return;
      var nombre = ($('#er-resv-name', raiz).value || '').trim();
      var t = ['Hola, El Ritual. Quiero reservar una mesa.', '',
        'Fecha: ' + R.fecha.toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }),
        'Hora: ' + hhmm(R.hora),
        'Personas: ' + R.gente + (R.gente === 12 ? ' o más' : ''),
        nombre ? ('Nombre: ' + nombre) : '', '',
        'Quedo a la espera de la confirmación. ¡Gracias!'].filter(Boolean).join('\n');
      window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(t), '_blank', 'noopener');
    });
    todo();
  }

  /* ---------------- aparicion progresiva ---------------- */
  function initReveal() {
    var els = $$('.rv:not([data-in])');
    if (!els.length) return;
    if (REDUCED) { els.forEach(function (e) { e.dataset.in = '1'; }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.dataset.in = '1'; io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function arrancar() {
    initHeader(); initCarrusel(); initRitual(); initReservas(); initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  // el editor de temas re-renderiza secciones sueltas
  document.addEventListener('shopify:section:load', arrancar);
})();
